export const CONSTANTS = {
	minimumColumns: 1,
	maximumColumns: 4,
	minimumColumnsValue: 0,
	maximumColumnsValue: 100000000,
	maximumUnits: 100000,
	maximumTiers: Number.MAX_VALUE,
};
